var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "information-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5279 20.4853H15.2841V15.5099H14.0403M15.2841 10.5346H15.2965M26.4786 15.5099C26.4786 16.98 26.1891 18.4357 25.6265 19.7939C25.0639 21.1521 24.2393 22.3861 23.1998 23.4256C22.1603 24.4652 20.9262 25.2897 19.5681 25.8523C18.2099 26.4149 16.7542 26.7044 15.2841 26.7044C13.814 26.7044 12.3583 26.4149 11.0002 25.8523C9.64197 25.2897 8.4079 24.4652 7.36839 23.4256C6.32889 22.3861 5.50431 21.1521 4.94173 19.7939C4.37915 18.4357 4.0896 16.98 4.0896 15.5099C4.0896 12.541 5.26902 9.6936 7.36839 7.59423C9.46777 5.49485 12.3151 4.31543 15.2841 4.31543C18.2531 4.31543 21.1004 5.49485 23.1998 7.59423C25.2992 9.6936 26.4786 12.541 26.4786 15.5099Z",
    stroke: "#C4C4C4",
    strokeWidth: 1.86575,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.f8516a6b1a0d685237fa37577d150aa0.svg";
export { ForwardRef as ReactComponent };